import { coreInstance, globalAxios } from "../index";
export default {
  namespaced: true,
  state: {
    userList: [],
    notificationList: []
  },
  mutations: {
    resetState(state) {
      state.userList = [];
    },
    fetchDataStaffList(state, data) {
      state.userList = data;
    },
    setNotificationData(state, data) {
      state.notificationList = data
    }
  },
  actions: {
    readNotification({ state, commit, rootState }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };

      form.notification_read_province = rootState.Auth.refeshProvince
      form.notification_read_store_id = rootState.Auth.refeshStoreID
      form.notification_read_user_id = rootState.Auth.userInfo.user_id
      return globalAxios
        .post(
          rootState.baseAPIURL + 'readNotification', form, axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return res.data.data.notifications;
          } else {
            return [];
          }
        })
        .catch(err => [])
    },
    fetchNotificationData({ state, commit, rootState }, current_page) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return globalAxios
        .get(
          rootState.baseAPIURL +
          'getNotification/store_id/' + rootState.Auth.refeshStoreID + '?current_page=' + current_page, axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return [];
          } else {
            return [];
          }
        })
        .catch(err => [])
    },
    resetPassword({ rootState, commit }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return coreInstance
        .post("/api/v1/merChant/resetPasswordNowStaff", form, axiosConfig)
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return true;
          } else {
            return false;
          }
        })
        .catch(err => false);
    },
    editUserInStore({ rootState, commit }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      form.store_id = rootState.Auth.refeshStoreID;
      return coreInstance
        .put(
          "/api/v1/merChant/editStaffByUserId/" + form.user_id,
          form,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          commit("fetchDataStaffList", res.data.data);
          return true;
        })
        .catch(err => false);
    },
    createManagerInStore({ rootState, commit }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      form.user_store_province_id =
        rootState.Auth.userInfo.data_permission.us_store_province_id;
      form.user_store_service_id =
        rootState.Auth.userInfo.data_permission.us_store_service_id;
      return coreInstance
        .post(
          "/api/v1/merChant/registerManagerByStore/" +
          rootState.Auth.refeshStoreID,
          form,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == 2 && res.data.status == false) {
            return 3
          }
          commit("fetchDataStaffList", res.data.data);
          return true;
        })
        .catch(err => {
          if (err.response.data.msg == 2 && err.response.data.status == false) {
            return 3
          }
          return false
        });
    },
    createStaffInStore({ rootState, commit }, form) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      form.user_store_province_id =
        rootState.Auth.userInfo.data_permission.us_store_province_id;
      form.user_store_service_id =
        rootState.Auth.userInfo.data_permission.us_store_service_id;
      return coreInstance
        .post(
          "/api/v1/merChant/registerStaffByStore/" +
          rootState.Auth.refeshStoreID,
          form,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == 2 && res.data.status == false) {
            return 3
          }
          commit("fetchDataStaffList", res.data.data);
          return true;
        })
        .catch(err => {
          if (err.response.data.msg == 2 && err.response.data.status == false) {
            return 3
          }
          return false
        });
    },
    fetchDataStaffList({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken
        }
      };
      return coreInstance
        .get(
          "/api/v1/merChant/restaurant/getStaff/" +
          rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then(res => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          commit("fetchDataStaffList", res.data.data);
          return res.data.data;
        })
        .catch(err => false);
    }
  },
  getters: {}
};
